module.exports = __webpack_public_path__ + "static/media/folder4.cdaaa197.png";